import SuccessPage from './SuccessPage';
export default SuccessPage;



// WEBPACK FOOTER //
// ./src/components/Payments/SuccessPage/index.js